/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShiftCountsRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {GetShiftCountsResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const getShiftCounts = (request: GetShiftCountsRequest, options?: CashRequestOptions) => post<GetShiftCountsRequest, GetShiftCountsResponse>("/proxy/services/squareup.timecards.TimeCalculationReportService/GetShiftCounts", request, {...options, rejectOnError: true })